import { PaymentReceiversService_paymentReceiverServiceGetGet } from '@festina/moneyout-general-types/moneyout/hooks/PaymentReceiversService_paymentReceiverServiceGetGet'

export const useFetchPaymentReceiverVersionLatest =
  PaymentReceiversService_paymentReceiverServiceGetGet.useSuspenseQuery
